import React from 'react'
import { Controller } from 'react-hook-form'
import { InputField } from './InputField'
import Hr from '../ui/Hr'

interface Props {
  fileds: any[]
  data: any[]
  title: string
}
interface PropsFields {
  classNameContainer: string
  typeComp: string
  controllerProps: any
  compProps: any
}

const FilterInputGroup = ({ fileds, data, title }: Props) => {
  return (
    <>
      <Hr className={'border-t w-64 sm:ml-4 mb-4 mr-6'} />
      <div className="mb-1 w-64 sm:ml-4">
        <h3 className="text-lg font-semibold mb-1">{title}</h3>

        {fileds.map(
          (
            {
              typeComp,
              classNameContainer,
              controllerProps,
              compProps,
            }: PropsFields,
            index: number,
          ) => {
            return (
              <React.Fragment key={index}>
                <Controller
                  {...controllerProps}
                  render={({ field, fieldState }) => (
                    <>
                      {typeComp === 'input' &&
                        data.map((ele: any, indx: number) => (
                          <div className={classNameContainer} key={indx}>
                            <InputField
                              key={indx} // Asegúrate de usar una key única aquí
                              {...compProps({ field, fieldState, ele })}
                            />
                          </div>
                        ))}
                    </>
                  )}
                />
              </React.Fragment>
            )
          },
        )}
      </div>
    </>
  )
}

export default FilterInputGroup
